import { CSSProperties } from 'react';
import { FelaCSS, colors } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
  property: FelaCSS;
  propertyAccomodation: FelaCSS;
  icon: CSSProperties;
}

const styles = (): IStyles => ({
  wrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    fontDefault: 14,
    color: colors.space60,
  },

  property: {
    whiteSpace: 'nowrap',
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 4,
  },
  propertyAccomodation: {
    maxWidthMobile: { display: 'none' },
  },
  icon: { marginRight: '6px' },
});

export default styles;
